import { render, staticRenderFns } from "./tjpeople.vue?vue&type=template&id=36a4a2f4&scoped=true"
import script from "./tjpeople.vue?vue&type=script&lang=js"
export * from "./tjpeople.vue?vue&type=script&lang=js"
import style0 from "./tjpeople.vue?vue&type=style&index=0&id=36a4a2f4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4a2f4",
  null
  
)

export default component.exports